export default {
  grupoFields: [
    { key: 'codigo', label: 'Cód' },
    { key: 'obra', label: 'Obra' },
    { key: 'data', label: 'Data' },
    { key: 'obs', label: 'Observação' },
    { key: 'user', label: 'Usuário' },
    { key: 'status', label: 'Status' },
    { key: 'actions', label: '' },
  ],
  
  grupoFieldsDashboard: [
    {
      key: 'codigo',
      label: 'Cód',
    },
    {
      key: 'obra',
      label: 'Obra',
    },
    {
      key: 'data',
      label: 'Data',
    },
    {
      key: 'obs',
      label: 'Observação',
    },
    {
      key: 'user',
      label: 'Usuário',
    },
    {
      key: 'actions',
      label: '',
    },
  ],
  excelColumns: [
    {
      label: 'Número da requisição',
      field: 'codigo',
    },
    {
      label: 'Data',
      field: 'data',
    },
    {
      label: 'Tipo',
      field: 'tipo',
    },
    {
      label: 'Torres',
      field: 'torres',
    },
    {
      label: 'Andares',
      field: 'andares',
    },
    {
      label: 'Observações',
      field: 'observations',
    },
    {
      label: 'Código',
      field: 'code',
    },
    {
      label: 'Itens',
      field: 'itens',
    },
    {
      label: 'Quantidade',
      field: 'quantity',
    },
    {
      label: 'Status',
      field: 'status',
    },
    {
      label: 'Requisição',
      field: 'request_user',
    },
    {
      label: 'Aprovação',
      field: 'approved_user',
    },
    {
      label: 'Conclusão',
      field: 'concluded_user',
    },
  ],
  indexesFields: [
    {
      key: 'obra.nome',
      label: 'Obra',
    },
    {
      key: 'data',
      label: 'Data',
    },
    {
      key: 'torres',
      label: 'Torres',
    },
    {
      key: 'andares',
      label: 'Andares',
    },
    {
      key: 'code',
      label: 'Código',
    },
    {
      key: 'materialRaw',
      label: 'Insumo',
    },
    {
      key: 'unit',
      label: 'Unidade',
    },
    {
      key: 'quantity',
      label: 'Quantidade',
    },
  ],
}
